<template>
    <div>
        <x-modal
            :wWidth="1080"
            v-if="isVisible"
            @cancel="closeApplicationModalClose"
            @close="closeApplicationModalClose"
            @ok="closeApplicationModalSubmit"
            :draggable="true"
            :resizable="true"
            :loading="loading"
            :okDisabled="closeApplicationModalButtonDisabled"
            okText="Close Application"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">Close Application</div>

            <div class="container">
                <el-form label-width="140px">
                    <el-form-item class="mt-4" label="Close Reason">
                        <el-select class="w-100" v-model="closeReason" placeholder="Close Reason">
                            <el-option
                                v-for="option in closeReasonOptions"
                                :key="option.value"
                                :label="option.label"
                                :value="option.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>

                    <template slot-sope="scope">
                        <el-form-item v-if="closeReason === this.triggerValue.value && this.triggerValue.label === 'Close Form Pack'" label="Select Form" >
                            <el-select class="w-100" v-model="closeReasonForm" placeholder="Select Forms">
                                <el-option
                                    :key="closeReasonFormArray.id"
                                    :label="closeReasonFormArray.name"
                                    :value="closeReasonFormArray.name"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </template>

                    <email-sending-options
                        v-if="hasCloseReasonEmail"
                        :show-send-email="hasCloseReasonEmail"
                        :show-send-sms="hasCloseReasonEmail && (_.isEmpty(appIds) || _.size(appIds) == 1)">
                    </email-sending-options>

                    <email-recipients
                        v-if="
							hasCloseReasonEmail &&
							(emailBuilder.sendEmail || emailBuilder.sendSms) &&
							(_.isEmpty(appIds) || _.size(appIds) == 1)
						"
                        :recipientType="recipientTypes"
                        :autoSelectType="recipientTypes"
                        :recipientAllowCreate="false"
                    ></email-recipients>

                    <email-task v-if="_.isEmpty(appIds) || _.size(appIds) == 1"
                                v-model="emailBuilder.task"></email-task>

                    <el-divider
                        v-if="
							!_.isEmpty(emailBuilder.recipients) &&
							(emailBuilder.sendEmail || emailBuilder.sendSms) &&
							(_.isEmpty(appIds) || _.size(appIds) == 1)
						"
                    ></el-divider>

                    <email-markup-multi
                        class="mb-3"
                        v-if="
							!_.isEmpty(emailBuilder.recipients) &&
							hasCloseReasonEmail &&
							(emailBuilder.sendEmail || emailBuilder.sendSms) &&
							(_.isEmpty(appIds) || _.size(appIds) == 1)
						"
                        action="close-application"
                        :key="closeReason"
                        :data="{
							closeReason: closeReason,
						}"
                    ></email-markup-multi>
                </el-form>
            </div>
        </x-modal>
    </div>
</template>

<script>
import EmailSendingOptions from "@ambition/components/messages/EmailSendingOptions.vue"
import EmailRecipients from "@ambition/components/messages/EmailRecipients"
import EmailAttachments from "@ambition/components/messages/EmailAttachments"
import EmailMarkupMulti from "@ambition/components/messages/EmailMarkupMulti"
import EmailTask from "@ambition/components/messages/EmailTask"
import {mapGetters, mapState} from "vuex"

export default {
    name: "CloseApplicationModal",
    props: {
        visible: {
            required: true,
            type: Boolean,
        },
        applicationIds: {
            required: false,
            type: Object,
            default: function () {
                return {}
            },
        },
        leadManagementTab: {
            required: false,
            default: false
        }
    },
    components: {
        EmailSendingOptions,
        EmailRecipients,
        EmailAttachments,
        EmailMarkupMulti,
        EmailTask,
    },
    data() {
        return {
            isVisible: false,
            loading: false,
            recipientTypes: ["applicant"],
            closeReasonOptions: [],
            closeReasonFormArray: [],
            closeEmailUid: [],
            closeReason: "",
            closeReasonForm: "",
            emailNotRequiredReasonIds: [],
            hasAction: false,
            triggerValue: [],
        }
    },
    watch: {
        visible(visible) {
            this.isVisible = visible
        },
        appIds: {
            handler(applicationIds) {
                if (!_.isEmpty(applicationIds) && _.size(applicationIds) == 1) {
                    this.emailBuilder.applicationId = Number(this.appIds[0])
                } else {
                    this.emailBuilder.applicationId = null
                }
            },
            immediate: true,
            deep: true
        },

        closeReason(newVal) {
            this.triggerValue = _.find(this.closeReasonOptions, function(o) { return o.value === newVal; });
            console.warn("Cool", this.triggerValue)
        }
    },
    mounted() {
        this.getCloseReasons()
        this.getCloseAction()
    },
    activated() {
    },
    computed: {
        ...mapGetters({
            emailBuilder: "builderEmail/getEmail",
            templatesLoaded: "builderEmail/checkTemplatesLoaded",
        }),
        appIds() {
            if (_.isEmpty(this.applicationIds)) return []
            let appIds = []
            Object.keys(this.applicationIds).forEach((key) => {
                if (this.applicationIds[key]) {
                    appIds.push(key)
                }
            });
            return appIds
        },
        hasCloseReasonEmail() {
            this.emailBuilder.sendEmail = false
            if (!this.closeReason) return false
            if (!this.emailNotRequiredReasonIds.includes(this.closeReason)) {
                this.emailBuilder.sendEmail = true
                return true
            }
            return false
        },
        closeApplicationModalButtonDisabled() {
            if (!this.closeReason) return true
            if (!this.hasCloseReasonEmail) return false
            if (!_.isEmpty(this.appIds) && _.size(this.appIds) > 1) return false
            if (!this.emailBuilder.sendEmail && !this.emailBuilder.sendSms) return false
            if (this.hasCloseReasonEmail && _.size(this.emailBuilder.recipients) < 1) return true
            if (!this.templatesLoaded) return true
            if (this.emailBuilder.delaySending && !this.emailBuilder.sendAt) return true
            return false
        },
    },
    methods: {

        getCloseReasons() {
            let headers = {
                headers: {Authorization: "Bearer " + this.$store.getters.token},
            }
            axios.post("/api/builder-close-reasons", headers).then((res) => {
                this.emailNotRequiredReasonIds = res.data.filter((reason) => !reason.notification_required).map((reason) => reason.id)
                this.closeReasonOptions = this.formatOptions(res.data)
            })
        },

        getCloseAction() {
            axios.get("/api/builder-close-action")
                .then((res) => {
                    this.closeReasonFormArray = res.data
                    this.hasAction = true
                })
        },

        formatOptions(data) {
            let options = []
            data.map((element) => {
                options.push({label: element.name, value: element.id})
            })
            return options
        },

        closeApplicationModalClose() {
            this.$store.dispatch('builderEmail/resetEmail')
            this.loading = false
            this.isVisible = false
            this.$emit("update:visible", false)
            this.$bus.$emit('lead-collection-reload', {
                listLoading: true
            })
        },

        async closeApplicationModalSubmit() {
            this.loading = true

            let data = {
                _method: _.isEmpty(this.appIds) || _.size(this.appIds) == 1 ? "DELETE" : "POST",
                close_reason: this.closeReason,
                email: this.emailBuilder,
                sendEmail: this.emailBuilder.sendEmail,
                appIds: this.appIds,
                hasCloseReasonEmail: this.hasCloseReasonEmail,
            }

            let appId = _.get(this.appIds, '0', this.$store.getters.appId);
            let headers = {headers: {Authorization: "Bearer " + this.$store.getters.token}}
            let endpoint = _.isEmpty(this.appIds) || _.size(this.appIds) == 1 ? "/admin/applications/" + appId : "/admin/applications/closeMultipleApplications"

            if (!_.isEmpty(this.appIds) || _.size(this.appIds) > 1) {
                this.$bus.$emit('lead::management::reload', true)
                this.$bus.$emit('lead::selectedCounter::reset', true)
                this.$bus.$emit('lead-collection-reload', {
                    listLoading: true
                })
                this.closeApplicationModalClose()
            }

            await axios.post(endpoint, data, headers).then((res) => {
                this.$bus.$emit('lead::management::reload', true)
                this.$bus.$emit('lead::selectedCounter::reset', true)
                this.$bus.$emit('lead-collection-reload', {
                    listLoading: true
                })
                if (_.isEmpty(this.appIds) || _.size(this.appIds) == 1) {

                    // create application task
                    if (_.get(this.emailBuilder, "task.create", false)) {
                        this.$store.dispatch("statusIndicators/changeStatus", {
                            stage: "createTask",
                            token: this.$store.getters.token,
                            remindMe: this.$moment(this.emailBuilder.task.remindMe).format("YYYY-MM-DD"),
                            taskName: this.emailBuilder.task.name,
                            time: this.emailBuilder.task.time,
                            userId: this.emailBuilder.task.userId,
                            appId: this.$store.getters.initAppData.id,
                        })
                    }

                    // create recipient tasks
                    if (_.get(this.emailBuilder, "recipients", false)) {
                        this.emailBuilder.recipients.forEach((recipient) => {
                            if (_.get(recipient, "template.task.create", false)) {
                                this.$store.dispatch("statusIndicators/changeStatus", {
                                    stage: "createTask",
                                    token: this.$store.getters.token,
                                    remindMe: this.$moment(recipient.template.task.remindMe).format("YYYY-MM-DD"),
                                    taskName: recipient.template.task.name,
                                    time: recipient.template.task.time,
                                    userId: recipient.template.task.userId,
                                    appId: this.$store.getters.initAppData.id,
                                })
                            }
                        })
                    }

                    this.$store.dispatch("updateAppStatus", 3)

                    const hasAppOpenedWindow = window.opener
                    if (hasAppOpenedWindow) {
                        swal({
                            title: "Application Closed",
                            text: "Would you like to close this tab, or return to all applications, or cancel to remain on page?",
                            type: "success",
                            showCloseButton: true,
                            showCancelButton: true,
                            cancelButtonText: "Cancel",
                            closeButtonText: "Close Tab",
                            cancelButtonColor: "red",
                            closeButtonColor: "#909399",
                            confirmButtonText: "All Applications",
                            confirmButtonColor: "#5cbb2a",
                        }).then((result) => {
                            this.loading = false
                            if (result.value) {
                                this.$bus.$emit('lead::management::reload', true)
                                this.$bus.$emit('lead-collection-reload', {
                                    listLoading: true
                                })
                                window.onbeforeunload = null
                                window.location.href = "/admin/applications"
                            } else if (result.isCanceled) {
                                this.$bus.$emit('lead::management::reload', true)
                                this.$bus.$emit('lead-collection-reload', {
                                    listLoading: true
                                })
                            } else {
                                this.$bus.$emit('lead::management::reload', true)
                                this.$bus.$emit('lead-collection-reload', {
                                    listLoading: true
                                })
                                window.onbeforeunload = null
                                window.open("", "_self", "").close()
                            }
                        })
                    } else {
                        if (!this.leadManagementTab) {
                            window.onbeforeunload = null
                            window.location.href = "/admin/applications"
                        } else {
                            this.$bus.$emit('lead::management::reload', true)
                            this.$bus.$emit('lead-collection-reload', {
                                listLoading: true
                            })
                        }
                    }

                    this.closeApplicationModalClose()
                }
            })
        },
    },
}
</script>
